import ModalDialog, { ModalTransition } from '@atlaskit/modal-dialog';
import { MergeDuplicateMetricsProvider } from './MergeDuplicateMetrics';
import React from 'react';
import UsageTab from '../../MetricSlideOut/UsageTab';
import FormHeader from '../../../../../kingpin/forms/FormHeader';
import FormContent from '../../../../../kingpin/forms/FormContent';
import Form from '../../../../../kingpin/forms/Form';
import { Scrollable } from '../../../../../components/UserPicker/UserPicker';

const UsagePopup = ({
  close,
  metric,
}: {
  close: () => void;
  metric: Metrics.NormalMetric;
}) => {
  return (
    <Form>
      <FormHeader title={`Usages for '${metric.name}'`} onClose={close} />
      <FormContent>
        <Scrollable style={{ maxHeight: 500, marginTop: 5, padding: 4 }}>
          <UsageTab metric={metric} />
        </Scrollable>
      </FormContent>
    </Form>
  );
};

const Gate = ({
  isOpen,
  close,
  metric,
}: {
  isOpen: boolean;
  close: () => void;
  metric: Metrics.NormalMetric;
}) => {
  return (
    <ModalTransition>
      {isOpen && (
        <ModalDialog
          width={450}
          onClose={close}
          shouldScrollInViewport={false}
          autoFocus={false}
        >
          <MergeDuplicateMetricsProvider>
            <UsagePopup metric={metric} close={close} />
          </MergeDuplicateMetricsProvider>
        </ModalDialog>
      )}
    </ModalTransition>
  );
};

export default Gate;
